import { useQuery } from "@tanstack/react-query";
import { statsRepo } from "@/lib/repositories";
import type { ApiKpiStatParams } from "../types";

export function useFetchKpis({ end_date, start_date }: ApiKpiStatParams) {
  const query = useQuery({
    queryKey: ["stats", "kpis", start_date, end_date],
    queryFn: () =>
      statsRepo.fetchKpis({
        end_date,
        start_date,
      }),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
}
